import GridContainer from '@rsa-digital/evo-shared-components/components/GridContainer';
import LogoLink from '@rsa-digital/evo-shared-components/components/LogoLink';
import RichText from '@rsa-digital/evo-shared-components/components/RichText';
import React from 'react';
import {
  GlobalNotificationContainer,
  GlobalNotificationContent,
  OuterContainer,
} from './styles';
import { GlobalNotificationProps } from './types';

const GlobalNotification: React.FC<GlobalNotificationProps> = ({
  imageLink,
  message,
}) => {
  return (
    <OuterContainer aria-label="Global Notification" role="region">
      <GridContainer>
        <GlobalNotificationContainer>
          <GlobalNotificationContent data-cy="GlobalNotification">
            {imageLink && <LogoLink logoLink={imageLink} />}
            <RichText html={message} />
          </GlobalNotificationContent>
        </GlobalNotificationContainer>
      </GridContainer>
    </OuterContainer>
  );
};

export default GlobalNotification;
